<template>
    <div>
        <order_invoice v-if="revise_order.finance" :order="revise_order"></order_invoice>
    </div>
</template>

<script>
    import order_invoice from "~/views/order/partial/order_invoice.vue";
    export default {
        name: "fill_invoice",
        props:{
            order_edit:{
                required:true
            }
        },
        components:{
            order_invoice
        },
        data(){
            return {
                revise_order:{
                    finance:{
                        invoice:[]
                    }
                }
            }
        },
        mounted(){
            this.revise_order.finance = {};
            this.revise_order.finance.invoice = [this.order_edit.content];
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/fill_invoice.vue